import { Component,OnDestroy,OnInit } from '@angular/core';
import { AbstractModal, BroadcastService, ModalButtonModel, ModalButtonType, ToasterType } from '@cv-invision/core';
import { Store } from '@ngxs/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LenderService } from '../../../service/lender.service';
import { SetXpanseSettings } from '../../../state/actions/global-configuration.actions';
import { GlobalConfigurationState } from '../../../state/global-configuration.state';
import { BranchModel, DefaultSettingsModel } from '../model/xpanse-default-setting.model';
import { XpanseDefaultSettingService } from '../service/xpanse-default-setting.service';

@Component({
    selector: 'cv-call-center-client-form',
    templateUrl: './call-center-client-form.html',
	styleUrls: ['./call-center-client-form.scss']
})

export class CallCenterClientComponent extends AbstractModal implements OnInit, OnDestroy {
	private atComponentDestroy = new Subject();
    public acuityBranchSelected: Array<BranchModel>;
	public acuityLenderBranchesList: Array<BranchModel>;
	public appScopeLendersList: Array<BranchModel>;
	public clientBranchSelected: Array<BranchModel>;
	public defaultConfigModel: DefaultSettingsModel;
	public callCenterClient: DefaultSettingsModel;
	public cmpAcuityBranchSelected: Array<BranchModel>;
	public cmpAcuityLenderBranchesList: Array<BranchModel>;
	public xpanseClientid: string;
	public saving :boolean;

    constructor(
		 private store: Store,
		 public lenderService: LenderService,
		 private xpanseDefaultSettingService:XpanseDefaultSettingService,
		 private broadcastService: BroadcastService,
		 ) {
            super();
			this.callCenterClient =  new DefaultSettingsModel();
			this.defaultConfigModel = this.store.selectSnapshot(GlobalConfigurationState.getXpanseSettings);
			this.acuityLenderBranchesList = this.store.selectSnapshot(GlobalConfigurationState.getAcuityLenderBranches);
			this.appScopeLendersList = this.store.selectSnapshot(GlobalConfigurationState.getAppScopeLenders);
			this.cmpAcuityLenderBranchesList = this.store.selectSnapshot(GlobalConfigurationState.getCmpAcuityLenderBranches);
			this.acuityBranchSelected = [];
			this.clientBranchSelected = [];
			this.cmpAcuityBranchSelected = [];
			this.saving = false;
    }

    ngOnInit() {
		if (this.data.isEditing) {
			this.callCenterClient = this.data;
			this.xpanseClientid = this.callCenterClient.xpanseClientId

			this.acuityBranchSelected = [{
				title: this.callCenterClient.defaultBranchName,
				id: this.callCenterClient.defaultBranchId
			}];

			this.clientBranchSelected = [{
				title: this.callCenterClient.defaultClientName,
				id: this.callCenterClient.defaultClientId
			}];

			if(this.callCenterClient.defaultCMPBranchId){
				this.cmpAcuityBranchSelected = [{
					title: this.callCenterClient.defaultCMPBranchName,
					id: this.callCenterClient.defaultCMPBranchId
				}];
			}

		}
        const saveButton: ModalButtonModel = {
			name: 'Save',
			text: 'Save',
			class: 'btn-sm cv-btn-blue',
			type: ModalButtonType.ACTION,
			disabled: (): boolean => !this.setIsFormValid() || this.saving,
			loading: (): boolean => this.saving,
			action: () => this.onSave()
		};

		const cancelButton: ModalButtonModel = {
			name: 'close',
			text: 'Close',
			class: 'btn-sm',
			type: ModalButtonType.ACTION,
			action: this.onCancel.bind(this)
		};
        this.buttons.push(cancelButton);
		this.buttons.push(saveButton);
    }

    /**
	 * on branch selected
	 * @param $event
	 */
	onBranchSelected($event: any, type: string): void {
		switch (type) {
			case 'acuityBranch':
				this.callCenterClient.defaultBranchId = $event?.id || '';
				this.callCenterClient.defaultBranchName = $event?.title || '';
				break;
			case 'cmpacuity':
				this.callCenterClient.defaultCMPBranchId = $event?.id || '';
				this.callCenterClient.defaultCMPBranchName = $event?.title || '';
				break;
			case 'appscopeClient':
				this.callCenterClient.defaultClientId = $event?.id || '';
				this.callCenterClient.defaultClientName = $event?.title || '';
				break;
		}
	}

    /**
     * save client
     */
    onSave():void {
		const defaultSettingsCopy =  JSON.parse(JSON.stringify( this.defaultConfigModel));
		if (this.data.isEditing) {
			defaultSettingsCopy.clients.forEach( c => {
				if (c.xpanseClientId === this.xpanseClientid) {
					c.defaultBranchId =this.callCenterClient.defaultBranchId;
					c.defaultBranchName =this.callCenterClient.defaultBranchName;
					c.defaultClientId =this.callCenterClient.defaultClientId;
					c.defaultClientName =this.callCenterClient.defaultClientName;
					c.defaultAppScopeUserCreation = this.callCenterClient .defaultAppScopeUserCreation;
					c.xpanseClientId = this.callCenterClient.xpanseClientId;
					c.defaultCMPBranchId =this.callCenterClient.defaultCMPBranchId;
					c.defaultCMPBranchName =this.callCenterClient.defaultCMPBranchName;
				}
			});
		} else {
			defaultSettingsCopy.clients.push(this.callCenterClient);
		}
		this.xpanseDefaultSettingService
			.saveXpanseDefaultSettings(defaultSettingsCopy)
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe(
				() => {
					this.store.dispatch(new SetXpanseSettings(defaultSettingsCopy));
					this.successHandleFunction();
					super.onAcceptSuccess({
						success: true
					});
				},
				error => {
					this.errorMsgFunction(error.error);
					super.onCancel();
				}
			);
    }

	/**
	 * Is form valid?
	 */
	 setIsFormValid(): boolean {
		const validForm = (
			   this.callCenterClient.xpanseClientId
			   && this.callCenterClient.xpanseClientId.trim().length > 0
			   && this.callCenterClient.defaultBranchId
			   && this.callCenterClient.defaultBranchId.trim().length > 0
			   &&this.callCenterClient.defaultClientId
			   && this.callCenterClient.defaultClientId.trim().length > 0
			   && this.callCenterClient.defaultAppScopeUserCreation
			   && this.callCenterClient.defaultAppScopeUserCreation.trim().length > 0
			   && this.callCenterClient.defaultCMPBranchId
			   && this.callCenterClient.defaultCMPBranchId.trim().length > 0
			);
		return validForm;
	}

	/**
	 * handle response from server
	 */
	 successHandleFunction(): void {
		const msg = `The Client was successfully Saved`;
		this.broadcastService.broadcast({
			name: ToasterType.SUCCESS,
			event: { message: msg }
		});
	}

	/**
	 * Display error message wheter the oparation wast´n success
	 * @param error
	 */
	errorMsgFunction(error: any): void {
		const { Error } = error;
		const event = {
			error: Error.split(':')[3].replace(/["}]/g, ''),
			autoClose: true
		};
		this.broadcastService.broadcast({
			name: ToasterType.ERROR,
			event: event
		});
	}

    onDismiss(): void {
		super.onCancel();
	}

	ngOnDestroy(): void {
		this.atComponentDestroy.next({});
		this.atComponentDestroy.unsubscribe();
	}
}
